module.exports = __webpack_public_path__ + "static/media/Horace Greeley - 1872.adb049de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Horace Greeley - 1872.jpg
// module id = 492
// module chunks = 0